import { Sesame } from '@oberoninternal/travelbase-ds/hooks/useSesame';
import React, { FC } from 'react';
import LoginContent from '@oberoninternal/travelbase-website/dist/components/LoginContent';
import { FormattedMessage } from 'react-intl';
import { useTenantContext } from '@oberoninternal/travelbase-website/dist/context/TenantContext';
import Modal from '@oberoninternal/travelbase-ds/components/layout/Modal';

type Props = Pick<Sesame, 'onClose' | 'open'>;

const LoginModal: FC<React.PropsWithChildren<Props>> = ({ onClose, open }) => {
    const { brandConfig } = useTenantContext();

    return (
        <Modal open={open} onClose={onClose} variant="regular">
            <LoginContent
                title={<FormattedMessage defaultMessage="Mijn {island}" values={{ island: brandConfig.name }} />}
                helperText={
                    <FormattedMessage defaultMessage="U ontvangt een e-mail met een persoonlijke link naar uw account" />
                }
                description={
                    <FormattedMessage defaultMessage="Bekijk uw reservering(en), doe een betaling, print uw voucher of geef een beoordeling op uw verblijf." />
                }
                landingUrl={`${process.env.NEXT_PUBLIC_BASE_URL}/my`}
            />
        </Modal>
    );
};

export default LoginModal;
